export default __webpack_public_path__ + "static/media/menuL_icon_02.c5359e71.png";